var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var baseColors = {
    white: '#FFFFFF',
    black: '#000000',
    transparent: 'transparent',
};
export var colors = {
    base: baseColors,
    primary: {
        gray: {
            25: '#FDFDFD',
            50: '#FAFAFA',
            100: '#F5F5F5',
            200: '#E9EAEB',
            300: '#D5D7DA',
            400: '#A4A7AE',
            500: '#717680',
            600: '#535862',
            700: '#414651',
            800: '#252B37',
            900: '#181D27',
            950: '#0A0D12',
        },
        beige: {
            25: '#FBFBF9',
            50: '#F6F6F1',
            100: '#EEEEE4',
            200: '#E8E8DC',
            300: '#D8D8CD',
            400: '#C3C3B9',
            500: '#AAAAA2',
            600: '#91918A',
            700: '#787873',
            800: '#5F5F5C',
            900: '#464644',
            950: '#2D2D2D',
        },
        brand: {
            25: '#F7FAFF',
            50: '#EEF4FF',
            100: '#D2E3FF',
            200: '#BCD4FF',
            300: '#8FB8FF',
            400: '#639BFF',
            500: '#367FFF',
            600: '#2A6FE3',
            700: '#265BB6',
            800: '#124EAB',
            900: '#063D8F',
            950: '#03295F',
        },
        error: {
            25: '#FFF8F6',
            50: '#FFF1EE',
            100: '#FFE3DC',
            200: '#FFC1B3',
            300: '#FEA089',
            400: '#FD5C36',
            500: '#F04438',
            600: '#D92D20',
            700: '#B94428',
            800: '#912018',
            900: '#762B19',
            950: '#541F12',
        },
        warning: {
            25: '#FEFAF2',
            50: '#FEF4E6',
            100: '#FDEBCF',
            200: '#FBD49A',
            300: '#F9C16D',
            400: '#F7AE41',
            500: '#E69535',
            600: '#D47C29',
            700: '#C3621C',
            800: '#B14910',
            900: '#903809',
            950: '#671D00',
        },
        success: {
            25: '#F6FEF9',
            50: '#ECFDF3',
            100: '#DCFAE6',
            200: '#ABEFC6',
            300: '#75E0A7',
            400: '#47CD89',
            500: '#2CB669',
            600: '#079455',
            700: '#067647',
            800: '#085D3A',
            900: '#074D31',
            950: '#053321',
        },
    },
    secondary: {
        grayBlue: {
            25: '#FCFCFD',
            50: '#F8F9FC',
            100: '#EAECF5',
            200: '#D5D9EB',
            300: '#B3B8DB',
            400: '#717BBC',
            500: '#4E5BA6',
            600: '#3E4784',
            700: '#363F72',
            800: '#293056',
            900: '#101323',
            950: '#0D0F1C',
        },
        grayCool: {
            25: '#FCFCFD',
            50: '#F9F9FB',
            100: '#EFF1F5',
            200: '#DCDFEA',
            300: '#B9C0D4',
            400: '#7D89B0',
            500: '#5D6B98',
            600: '#4A5578',
            700: '#404968',
            800: '#30374F',
            900: '#111322',
            950: '#0E101B',
        },
        grayModern: {
            25: '#FCFCFD',
            50: '#F8FAFC',
            100: '#EEF2F6',
            200: '#E3E8EF',
            300: '#CDD5DF',
            400: '#9AA4B2',
            500: '#697586',
            600: '#4B5565',
            700: '#364152',
            800: '#202939',
            900: '#121926',
            950: '#0D121C',
        },
        grayNeutral: {
            25: '#FCFCFD',
            50: '#F9FAFB',
            100: '#F3F4F6',
            200: '#E5E7EB',
            300: '#D2D6DB',
            400: '#9DA4AE',
            500: '#6C737F',
            600: '#4D5761',
            700: '#384250',
            800: '#1F2A37',
            900: '#111927',
            950: '#0D121C',
        },
        grayIron: {
            25: '#FCFCFC',
            50: '#FAFAFA',
            100: '#F4F4F5',
            200: '#E4E4E7',
            300: '#D1D1D6',
            400: '#A0A0AB',
            500: '#70707B',
            600: '#51525C',
            700: '#3F3F46',
            800: '#26272B',
            900: '#1A1A1E',
            950: '#131316',
        },
        grayTrue: {
            25: '#FCFCFC',
            50: '#F7F7F7',
            100: '#F5F5F5',
            200: '#E5E5E5',
            300: '#D6D6D6',
            400: '#A3A3A3',
            500: '#737373',
            600: '#525252',
            700: '#424242',
            800: '#292929',
            900: '#141414',
            950: '#0F0F0F',
        },
        grayWarm: {
            25: '#FDFDFC',
            50: '#FAFAF9',
            100: '#F5F5F4',
            200: '#E7E5E4',
            300: '#D7D3D0',
            400: '#A9A29D',
            500: '#79716B',
            600: '#57534E',
            700: '#44403C',
            800: '#292524',
            900: '#1C1917',
            950: '#171412',
        },
        moss: {
            25: '#FAFDF7',
            50: '#F5FBEE',
            100: '#E6F4D7',
            200: '#CEEAB0',
            300: '#ACDC79',
            400: '#86CB3C',
            500: '#669F2A',
            600: '#4F7A21',
            700: '#3F621A',
            800: '#335015',
            900: '#2B4212',
            950: '#1A280B',
        },
        greenLight: {
            25: '#FAFEF5',
            50: '#F3FEE7',
            100: '#E4FBCC',
            200: '#D0F8AB',
            300: '#A6EF67',
            400: '#85E13A',
            500: '#66C61C',
            600: '#4CA30D',
            700: '#3B7C0F',
            800: '#326212',
            900: '#2B5314',
            950: '#15290A',
        },
        green: {
            25: '#F6FEF9',
            50: '#EDFCF2',
            100: '#D3F8DF',
            200: '#AAF0C4',
            300: '#73E2A3',
            400: '#3CCB7F',
            500: '#16B364',
            600: '#099250',
            700: '#087443',
            800: '#095C37',
            900: '#084C2E',
            950: '#052E1C',
        },
        teal: {
            25: '#F6FEFC',
            50: '#F0FDF9',
            100: '#CCFBEF',
            200: '#99F6E0',
            300: '#5FE9D0',
            400: '#2ED3B7',
            500: '#15B79E',
            600: '#0E9384',
            700: '#107569',
            800: '#125D56',
            900: '#134E48',
            950: '#0A2926',
        },
        cyan: {
            25: '#F5FEFF',
            50: '#ECFDFF',
            100: '#CFF9FE',
            200: '#A5F0FC',
            300: '#67E3F9',
            400: '#22CCEE',
            500: '#06AED4',
            600: '#088AB2',
            700: '#0E7090',
            800: '#155B75',
            900: '#164C63',
            950: '#0D2D3A',
        },
        blueLight: {
            25: '#F5FBFF',
            50: '#F0F9FF',
            100: '#E0F2FE',
            200: '#B9E6FE',
            300: '#7CD4FD',
            400: '#36BFFA',
            500: '#0BA5EC',
            600: '#0086C9',
            700: '#026AA2',
            800: '#065986',
            900: '#0B4A6F',
            950: '#062C41',
        },
        blue: {
            25: '#F5FAFF',
            50: '#EFF8FF',
            100: '#D1E9FF',
            200: '#B2DDFF',
            300: '#84CAFF',
            400: '#53B1FD',
            500: '#2E90FA',
            600: '#1570EF',
            700: '#175CD3',
            800: '#1849A9',
            900: '#194185',
            950: '#102A56',
        },
        blueDark: {
            25: '#F5F8FF',
            50: '#EFF4FF',
            100: '#D1E0FF',
            200: '#B2CCFF',
            300: '#84ADFF',
            400: '#528BFF',
            500: '#2970FF',
            600: '#155EEF',
            700: '#004EEB',
            800: '#0040C1',
            900: '#00359E',
            950: '#002266',
        },
        indigo: {
            25: '#F5F8FF',
            50: '#EEF4FF',
            100: '#E0EAFF',
            200: '#C7D7FE',
            300: '#A4BCFD',
            400: '#8098F9',
            500: '#6172F3',
            600: '#444CE7',
            700: '#3538CD',
            800: '#2D31A6',
            900: '#2D3282',
            950: '#1F235B',
        },
        violet: {
            25: '#FBFAFF',
            50: '#F5F3FF',
            100: '#ECE9FE',
            200: '#DDD6FE',
            300: '#C3B5FD',
            400: '#A48AFB',
            500: '#875BF7',
            600: '#7839EE',
            700: '#6927DA',
            800: '#5720B7',
            900: '#491C96',
            950: '#2E125E',
        },
        purple: {
            25: '#FAFAFF',
            50: '#F4F3FF',
            100: '#EBE9FE',
            200: '#D9D6FE',
            300: '#BDB4FE',
            400: '#9B8AFB',
            500: '#7A5AF8',
            600: '#6938EF',
            700: '#5925DC',
            800: '#4A1FB8',
            900: '#3E1C96',
            950: '#27115F',
        },
        fuschia: {
            25: '#FEFAFF',
            50: '#FDF4FF',
            100: '#FBE8FF',
            200: '#F6D0FE',
            300: '#EEAAFD',
            400: '#E478FA',
            500: '#D444F1',
            600: '#BA24D5',
            700: '#9F1AB1',
            800: '#821890',
            900: '#6F1877',
            950: '#47104C',
        },
        pink: {
            25: '#FEF6FB',
            50: '#FDF2FA',
            100: '#FCE7F6',
            200: '#FCCEEE',
            300: '#FAA7E0',
            400: '#F670C7',
            500: '#EE46BC',
            600: '#DD2590',
            700: '#C11574',
            800: '#9E165F',
            900: '#851651',
            950: '#4E0D30',
        },
        rose: {
            25: '#FFF5F6',
            50: '#FFF1F3',
            100: '#FFE4E8',
            200: '#FECDD6',
            300: '#FEA3B4',
            400: '#FD6F8E',
            500: '#F63D68',
            600: '#E31B54',
            700: '#C01048',
            800: '#A11043',
            900: '#89123E',
            950: '#510B24',
        },
        orangeDark: {
            25: '#FFF9F5',
            50: '#FFF4ED',
            100: '#FFE6D5',
            200: '#FFD6AE',
            300: '#FF9C66',
            400: '#FF692E',
            500: '#FF4405',
            600: '#E62E05',
            700: '#BC1B06',
            800: '#97180C',
            900: '#771A0D',
            950: '#57130A',
        },
        orange: {
            25: '#FEFAF5',
            50: '#FEF6EE',
            100: '#FDEAD7',
            200: '#F9DBAF',
            300: '#F7B27A',
            400: '#F38744',
            500: '#EF6820',
            600: '#E04F16',
            700: '#B93815',
            800: '#932F19',
            900: '#772917',
            950: '#511C10',
        },
        yellow: {
            25: '#FEFDF0',
            50: '#FEFBE8',
            100: '#FEF7C3',
            200: '#FEEE95',
            300: '#FDE272',
            400: '#FAC515',
            500: '#EAAA08',
            600: '#CA8504',
            700: '#A15C07',
            800: '#854A0E',
            900: '#713B12',
            950: '#542C0D',
        },
    },
};
var COLOR_NAME_TOKENS = Object.entries(colors).reduce(function (acc, _a) {
    var category = _a[0], palettes = _a[1];
    if (category === 'base') {
        Object.entries(palettes).forEach(function (_a) {
            var colorName = _a[0], value = _a[1];
            var key = "Base/".concat(colorName.charAt(0).toUpperCase() + colorName.slice(1));
            acc[key] = value;
        });
    }
    else {
        Object.entries(palettes).forEach(function (_a) {
            var colorName = _a[0], scales = _a[1];
            Object.entries(scales).forEach(function (_a) {
                var scale = _a[0], value = _a[1];
                var key = "".concat(colorName.charAt(0).toUpperCase() + colorName.slice(1), "/").concat(scale);
                acc[key] = value;
            });
        });
    }
    return acc;
}, {});
export var COLOR_TOKENS = __assign({ 'Colors/Base/White': baseColors.white, 'Colors/Base/Black': baseColors.black, 'Colors/Base/Transparent': baseColors.transparent, 'Colors/Text/text-primary': colors.primary.gray[900], 'Colors/Text/text-primary-on-brand': baseColors.white, 'Colors/Text/text-secondary': colors.primary.gray[700], 'Colors/Text/text-secondary-hover': colors.primary.gray[800], 'Colors/Text/text-secondary-on-brand': colors.primary.brand[200], 'Colors/Text/text-tertiary': colors.primary.gray[600], 'Colors/Text/text-tertiary-hover': colors.primary.gray[700], 'Colors/Text/text-tertiary-on-brand': colors.primary.brand[200], 'Colors/Text/text-quaternary': colors.primary.gray[500], 'Colors/Text/text-quaternary-on-brand': colors.primary.brand[300], 'Colors/Text/text-white': baseColors.white, 'Colors/Text/text-disabled': colors.primary.gray[500], 'Colors/Text/text-placeholder': colors.primary.gray[500], 'Colors/Text/text-placeholder-subtle': colors.primary.gray[300], 'Colors/Text/text-brand-primary': colors.primary.brand[900], 'Colors/Text/text-brand-secondary': colors.primary.brand[700], 'Colors/Text/text-brand-tertiary': colors.primary.brand[600], 'Colors/Text/text-brand-tertiary-alt': colors.primary.brand[600], 'Colors/Text/text-error-primary': colors.primary.error[600], 'Colors/Text/text-warning-primary': colors.primary.warning[600], 'Colors/Text/text-success-primary': colors.primary.success[600], 'Colors/Border/border-primary': colors.primary.gray[300], 'Colors/Border/border-secondary': colors.primary.gray[200], 'Colors/Border/border-tertiary': colors.primary.gray[100], 'Colors/Border/border-disabled': colors.primary.gray[300], 'Colors/Border/border-disabled-subtle': colors.primary.gray[200], 'Colors/Border/border-brand': colors.primary.brand[500], 'Colors/Border/border-brand-alt': colors.primary.brand[600], 'Colors/Border/border-error': colors.primary.error[500], 'Colors/Border/border-error-subtle': colors.primary.error[300], 'Colors/Foreground/fg-primary': colors.primary.gray[900], 'Colors/Foreground/fg-secondary': colors.primary.gray[700], 'Colors/Foreground/fg-secondary-hover': colors.primary.gray[800], 'Colors/Foreground/fg-tertiary': colors.primary.gray[600], 'Colors/Foreground/fg-tertiary-hover': colors.primary.gray[700], 'Colors/Foreground/fg-quaternary': colors.primary.gray[500], 'Colors/Foreground/fg-quaternary-hover': colors.primary.gray[600], 'Colors/Foreground/fg-quinary': colors.primary.gray[400], 'Colors/Foreground/fg-quinary-hover': colors.primary.gray[500], 'Colors/Foreground/fg-senary': colors.primary.gray[300], 'Colors/Foreground/fg-white': baseColors.white, 'Colors/Foreground/fg-disabled': colors.primary.gray[400], 'Colors/Foreground/fg-disabled-subtle': colors.primary.gray[300], 'Colors/Foreground/fg-brand-primary': colors.primary.brand[600], 'Colors/Foreground/fg-brand-primary-alt': colors.primary.brand[600], 'Colors/Foreground/fg-brand-secondary': colors.primary.brand[500], 'Colors/Foreground/fg-error-primary': colors.primary.error[600], 'Colors/Foreground/fg-error-secondary': colors.primary.error[500], 'Colors/Foreground/fg-warning-primary': colors.primary.warning[600], 'Colors/Foreground/fg-warning-secondary': colors.primary.warning[500], 'Colors/Foreground/fg-success-primary': colors.primary.success[600], 'Colors/Foreground/fg-success-secondary': colors.primary.success[500], 'Colors/Background/bg-primary': baseColors.white, 'Colors/Background/bg-primary-alt': baseColors.white, 'Colors/Background/bg-primary-hover': colors.primary.gray[50], 'Colors/Background/bg-primary-solid': colors.primary.gray[950], 'Colors/Background/bg-secondary': colors.primary.gray[50], 'Colors/Background/bg-secondary-alt': colors.primary.gray[50], 'Colors/Background/bg-secondary-hover': colors.primary.gray[100], 'Colors/Background/bg-secondary-subtle': colors.primary.gray[25], 'Colors/Background/bg-secondary-solid': colors.primary.gray[600], 'Colors/Background/bg-tertiary': colors.primary.gray[100], 'Colors/Background/bg-quaternary': colors.primary.gray[200], 'Colors/Background/bg-active': colors.primary.gray[50], 'Colors/Background/bg-disabled': colors.primary.gray[100], 'Colors/Background/bg-disabled-subtle': colors.primary.gray[50], 'Colors/Background/bg-overlay': colors.primary.gray[950], 'Colors/Background/bg-brand-primary': colors.primary.brand[50], 'Colors/Background/bg-brand-primary-alt': colors.primary.brand[50], 'Colors/Background/bg-brand-secondary': colors.primary.brand[100], 'Colors/Background/bg-brand-solid': colors.primary.brand[600], 'Colors/Background/bg-brand-solid-hover': colors.primary.brand[700], 'Colors/Background/bg-brand-section': colors.primary.brand[800], 'Colors/Background/bg-brand-section-subtle': colors.primary.brand[700], 'Colors/Background/bg-error-primary': colors.primary.error[50], 'Colors/Background/bg-error-secondary': colors.primary.error[100], 'Colors/Background/bg-error-solid': colors.primary.error[600], 'Colors/Background/bg-warning-primary': colors.primary.warning[50], 'Colors/Background/bg-warning-secondary': colors.primary.warning[100], 'Colors/Background/bg-warning-solid': colors.primary.warning[600], 'Colors/Background/bg-success-primary': colors.primary.success[50], 'Colors/Background/bg-success-secondary': colors.primary.success[100], 'Colors/Background/bg-success-solid': colors.primary.success[600] }, COLOR_NAME_TOKENS);
